import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import Text from '../text';
import Colors from '../colors';
import Spacer from '../spacer';
import ProgressBar from '../progress-bar';
const StyledProgressContainer = styled.View`
  margin: 0 14px;
`;
const styles = {
  title: {
    textAlign: 'center'
  },
  description: {
    lineHeight: 16,
    textAlign: 'center',
    letterSpacing: '0.25px'
  },
  progressPadding: {
    margin: '30px'
  }
};
export default function ProgressHeader(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text.H5, {
    color: Colors.black,
    weight: "medium",
    style: styles.title
  }, props.title), /*#__PURE__*/React.createElement(Spacer, {
    size: "f24",
    height: true
  }), /*#__PURE__*/React.createElement(StyledProgressContainer, null, /*#__PURE__*/React.createElement(ProgressBar, {
    progress: props.progress
  })), /*#__PURE__*/React.createElement(Spacer, {
    size: "f8",
    height: true
  }), /*#__PURE__*/React.createElement(Text, {
    color: Colors.gray200,
    style: styles.description
  }, props.description, ' ', props.progress, "%"));
}
ProgressHeader.propTypes = {
  title: PropTypes.string,
  progress: PropTypes.number,
  description: PropTypes.string
};
ProgressHeader.defaultProps = {
  title: '',
  progress: 0,
  description: 'Uploading'
};
//# sourceMappingURL=index.js.map